import { ConfigurationSourceDataMap } from "@/api/dtos";
import { AppSettings } from "@/AppSettings";
import ConfigurationSourceDataEventForm from "@/components/forms/forms/source-data-configuration/ConfigurationSourceDataEventForm";
import ConfigurationSourceDataFormForm from "@/components/forms/forms/source-data-configuration/ConfigurationSourceDataFormForm";
import MetadataContext from "@/contexts/data/MetadataContext";
import TrialContext from "@/contexts/data/TrialContext";
import ConfigurationSourceDataFormContext from "@/contexts/form/ConfigurationSourceDataFormContext";
import useEventConfiguration from "@/hooks/form/configuration/useEventConfiguration";
import useFormConfiguration from "@/hooks/form/configuration/useFormConfiguration";
import useDebouncedValue from "@/hooks/utility/useDebouncedValue";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Alert, AlertTitle } from "@mui/material";
import { useScopedField } from "@ngt/forms-core";
import { FC, useCallback, useContext } from "react";
import { useParams } from "react-router-dom";

const ConfigurationSourceDataForm: FC = () => {
    const { studyEventOid, caseReportFormOid } = useParams();

    const { data: trial } = useContext(TrialContext);
    const { data: metadata } = useContext(MetadataContext);
    const { state: { value: configuration } } = useScopedField<ConfigurationSourceDataMap>('configuration', { value: true });
    const { state: { value: trialConfiguration } } = useScopedField<ConfigurationSourceDataMap>('trialConfiguration', { value: true });


    const {
        state: debouncedConfiguration,
        doNotDebounceNextUpdate: doNoteDebounceNextConfigurationUpdate
    } = useDebouncedValue(configuration, 500);

    const {
        state: debouncedTrialConfiguration,
        doNotDebounceNextUpdate: doNoteDebounceNextTrialConfigurationUpdate
    } = useDebouncedValue(trialConfiguration, 500);

    const onLinkUpdate = useCallback(() => {
        doNoteDebounceNextConfigurationUpdate();
        doNoteDebounceNextTrialConfigurationUpdate();
    }, [doNoteDebounceNextConfigurationUpdate, doNoteDebounceNextTrialConfigurationUpdate]) 

    const { baseRoute } = useContext(ConfigurationSourceDataFormContext);

    const formData = useFormConfiguration(
        metadata,
        debouncedTrialConfiguration ?? undefined,
        debouncedConfiguration ?? undefined,
        trial,
        debouncedConfiguration?.configuration?.id,
        studyEventOid,
        caseReportFormOid,
        baseRoute
    );

    if (!formData) {
        return (
            <Alert
                icon={<FontAwesomeIcon icon={AppSettings.icons.alertWarning} />}
                severity="warning"
            >
                <AlertTitle>Form Not Found</AlertTitle>
                The {studyEventOid} {caseReportFormOid} form was not found.
            </Alert> 
        )
    }

    return (
        <>
            <ConfigurationSourceDataFormForm
                data={formData}
                onLinkUpdate={onLinkUpdate}
            />
        </>
    )
};

export default ConfigurationSourceDataForm;